import { render, staticRenderFns } from "./checkAssetDetail.vue?vue&type=template&id=21463ab2&scoped=true&"
import script from "./checkAssetDetail.vue?vue&type=script&lang=js&"
export * from "./checkAssetDetail.vue?vue&type=script&lang=js&"
import style0 from "./checkAssetDetail.vue?vue&type=style&index=0&id=21463ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21463ab2",
  null
  
)

export default component.exports